import React from 'react';
import './NotificationAndAlerts.css';

const NotificationAndAlerts = () => {
  return (
    <div className="NotificationAndAlerts">
      <h1>NotificationAndAlerts</h1>
    </div>
  );
};

export default NotificationAndAlerts;
